<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4279_1347)">
      <path
        d="M2.15277 4.72217H9.09722V6.11106C9.09722 7.06592 8.31597 7.84717 7.3611 7.84717H3.88888C2.93402 7.84717 2.15277 7.06592 2.15277 6.11106V4.72217Z"
        :stroke="stroke"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.45831 4.72217H9.79165"
        :stroke="stroke"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.3194 2.63889C6.3194 1.875 6.9444 1.25 7.70829 1.25C8.47217 1.25 9.09717 1.875 9.09717 2.63889V4.72222"
        :stroke="stroke"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.55898 7.8125L3.1944 8.88889"
        :stroke="stroke"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.69098 7.8125L8.05556 8.88889"
        :stroke="stroke"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4279_1347">
        <rect
          width="10"
          height="10"
          fill="white"
          transform="translate(0.625)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
import {DEFAULT_BRAND_COLOR} from '../constants';

export default {
  inject: ['getBrandPrimaryBackground'],
  computed: {
    stroke() {
      const stroke = this.getBrandPrimaryBackground();
      console.log('brand primary background: ', stroke);
      return stroke || DEFAULT_BRAND_COLOR;
    },
  },
};
</script>
